module.exports = __webpack_public_path__ + "media/images/gallery/constellations/names_layer_off-3edbc7349fc584f87d582beda63e4830.png";